import Modal from "common/Modal/Modal";
import React, { useEffect, useState } from "react";
import { useUser } from "@shared/utils/hooks/misc";
import { sharedLib } from "@shared/services/shared.service";
import Text from "common/Typography/Text";
import {
  PRIVACY_POLICY_LINK,
  TERMS_OF_USE_LINK,
} from "@shared/common/constants";
import Checkbox from "common/Checkbox/Checkbox";
import Flex from "common/Boxes/Flex";
import Button from "common/Buttons/Button";
import { useDispatch } from "react-redux";
import { useBranding } from "@shared/utils/hooks/useBranding.ts";
import { CheckboxChangeEvent } from "antd/es/checkbox";

const AcceptTermsModal = () => {
  const { user } = useUser();
  const { isWhitelabel } = useBranding();
  const [isOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [acceptTerms] = sharedLib.sharedApi.common.useAcceptTermsMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && !user.accepted_terms) {
      setIsOpen(true);
    }
  }, [user]);

  const handleOk = () => {
    setIsOpen(false);
    acceptTerms();
    dispatch(
      sharedLib.slices.authentication.actions.updateUser({
        key: "accepted_terms",
        value: true,
      })
    );
  };

  const footer = (
    <Flex $justifyContent="flex-end">
      <Button type="primary" disabled={!checked} onClick={handleOk}>
        OK
      </Button>
    </Flex>
  );

  return (
    <Modal
      open={isOpen}
      title="Please Accept our Terms"
      okButtonProps={{ disabled: !checked }}
      footer={footer}
      maskClosable={false}
      closable={false}
    >
      <Text>
        {`To continue${
          isWhitelabel ? ", " : " using Cornix, "
        }you must accept our `}
        <a href={TERMS_OF_USE_LINK} target="blank">
          Terms of Use
        </a>{" "}
        and{" "}
        <a href={PRIVACY_POLICY_LINK} target="blank">
          Privacy Policy
        </a>
        .
      </Text>
      <Checkbox
        onChange={(e: CheckboxChangeEvent) => setChecked(e.target.checked)}
        checked={checked}
        style={{ marginTop: 12 }}
      >
        <Text style={{ marginLeft: 4 }}>
          {`I have read and agree to ${
            isWhitelabel ? "the" : "Cornix's"
          } Terms of Use and Privacy Policy.`}
        </Text>
      </Checkbox>
    </Modal>
  );
};

export default AcceptTermsModal;
